/**
 * External dependencies
 */

import React from "react";
import classNames from "classnames";
import { Box, Text } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import Icon from "components/icon";

const Item = (props) => {
  const { label, icon, onClick, selected, className } = props;
  return (
    <Box
      component="button"
      className={classNames(className, "topbar-link", { selected })}
      onClick={onClick}
    >
      {icon && (
        <Box className="topbar__item-icon">
          <Icon style={{ fontSize: 25 }} {...icon} />
        </Box>
      )}
      <Text size="large">{label}</Text>
    </Box>
  );
};

export default Item;
